// @ts-nocheck
import { Column } from 'react-table'
import { GroupPricingInfoCell } from './GroupPricingInfoCell'
import { GroupPricingActionsCell } from './GroupPricingActionsCell'
import { GroupPricingSelectionCell } from './GroupPricingSelectionCell'
import { GroupPricingCustomHeader } from './GroupPricingCustomHeader'
import { GroupPricingSelectionHeader } from './GroupPricingSelectionHeader'
import { GroupPricing } from '../../core/_models'
import { FormattedMessage } from 'react-intl'

const grouppricingsColumns: ReadonlyArray<Column<GroupPricing>> = [
  {
    Header: (props) => <GroupPricingSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <GroupPricingSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <GroupPricingCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPPRICING.TABLE.COLUMN.GROUPNAME" defaultMessage="نام گروه" />}
        className="min-w-125px"
      />
    ),
    id: 'reseller_group',
    accessor: 'reseller_group.name',
  },
  {
    Header: (props) => (
      <GroupPricingCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPPRICING.TABLE.COLUMN.SERVICE" defaultMessage="سرویس" />}
        className="min-w-200px"
      />
    ),
    id: 'service',
    accessor: (row) => {
      const serviceCategory = row.service?.service_category?.category_name || 'کریدیت'
      const companyName = row.service?.company?.company_name || 'کریدیت'
      return `${serviceCategory} - ${companyName}`
    },
  },
  {
    Header: (props) => (
      <GroupPricingCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPPRICING.TABLE.COLUMN.BUNDLE" defaultMessage="بسته" />}
        className="min-w-125px"
      />
    ),
    id: 'bundle',
    accessor: 'bundle.bundle_title',
  },
  {
    Header: (props) => (
      <GroupPricingCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPPRICING.TABLE.COLUMN.MARKUPPERCENTAGE" defaultMessage="درصد افزایش قیمت" />}
        className="min-w-125px"
      />
    ),
    id: 'markup_percentage',
    accessor: 'markup_percentage',
  },
  {
    Header: (props) => (
      <GroupPricingCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPPRICING.TABLE.COLUMN.FIXEDFEE" defaultMessage="هزینه ثابت" />}
        className="min-w-100px"
      />
    ),
    id: 'fixed_fee',
    accessor: 'fixed_fee',
  },
  {
    Header: (props) => (
      <GroupPricingCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPPRICING.TABLE.COLUMN.USEMARKUP" defaultMessage="استفاده از فیصدی قیمت" />}
        className="min-w-125px"
      />
    ),
    id: 'use_markup',
    Cell: ({ row }) => (
      <span className={`badge ${row.original.use_markup ? 'badge-success' : 'badge-danger'}`}>
        {row.original.use_markup ? 'فعال' : 'غیرفعال'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <GroupPricingCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPPRICING.TABLE.COLUMN.USEFIXEDFEE" defaultMessage="استفاده از هزینه ثابت" />}
        className="min-w-125px"
      />
    ),
    id: 'use_fixed_fee',
    Cell: ({ row }) => (
      <span className={`badge ${row.original.use_fixed_fee ? 'badge-success' : 'badge-danger'}`}>
        {row.original.use_fixed_fee ? 'فعال' : 'غیرفعال'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <GroupPricingCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPPRICING.TABLE.COLUMN.STATUS" defaultMessage="وضعیت" />}
        className="min-w-100px"
      />
    ),
    id: 'status',
    Cell: ({ row }) => (
      <span className={`badge ${row.original.status === 'active' ? 'badge-success' : 'badge-danger'}`}>
        {row.original.status === 'active' ? 'فعال' : 'غیرفعال'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <GroupPricingCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPPRICING.TABLE.COLUMN.NOTES" defaultMessage="یادداشت‌ها" />}
        className="min-w-150px"
      />
    ),
    id: 'notes',
    accessor: 'notes',
  },
  {
    Header: (props) => (
      <GroupPricingCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPPRICING.TABLE.COLUMN.CREATEDAT" defaultMessage="تاریخ ایجاد" />}
        className="min-w-150px"
      />
    ),
    id: 'created_at',
    accessor: 'created_at',
  },
  {
    Header: (props) => (
      <GroupPricingCustomHeader
        tableProps={props}
        title={<FormattedMessage id="TABLE.GENERAL.ACTION" defaultMessage="عملیات" />}
        className="text-end min-w-100px"
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => <GroupPricingActionsCell id={props.data[props.row.index].id} />,
  },
]

export { grouppricingsColumns }
